import { themeData } from './xmlConvert';
import { ElectronApi } from '../electron.api';
import {
  getThemeTableTotalCount,
  totalThemeRecordCount
} from './xmlConvert/constant';

export function int8(num: number): Buffer {
  const buf = Buffer.alloc(1);
  num = Number(num);
  if (num < -128 || num > 127 || !Number.isFinite(num)) {
    console.warn(`[BIN] int8 overflow: ${num}`);
    num = Math.min(Math.max(-128, num | 0), 127);
  }
  buf.writeInt8(num);
  return buf;
}

export function int16(num: number): Buffer {
  const buf = Buffer.alloc(2);
  num = Number(num);
  if (num < -32768 || num > 32767 || !Number.isFinite(num)) {
    console.warn(`[BIN] int16 overflow: ${num}`);
    num = Math.min(Math.max(-32768, num | 0), 32767);
  }
  buf.writeInt16LE(num);
  return buf;
}

export function int32(num: number): Buffer {
  const buf = Buffer.alloc(4);
  num = Number(num);
  if (num < -2147483648 || num > 2147483647 || !Number.isFinite(num)) {
    console.warn(`[BIN] int32 overflow: ${num}`);
    num = Math.min(Math.max(-2147483648, num | 0), 2147483647);
  }
  buf.writeInt32LE(num);
  return buf;
}

export function uint8(num: number): Buffer {
  const buf = Buffer.alloc(1);
  num = Number(num);
  if (num < 0 || num > 0xff || !Number.isFinite(num)) {
    console.warn(`[BIN] uint8 overflow: ${num}, clamped to ${Math.min(Math.max(0, num >>> 0), 0xff)}`);
    num = Math.min(Math.max(0, num >>> 0), 0xff);
  }
  buf.writeUInt8(num);
  return buf;
}

export function uint16(num: number): Buffer {
  const buf = Buffer.alloc(2);
  num = Number(num);
  if (num < 0 || num > 0xffff || !Number.isFinite(num)) {
    console.warn(`[BIN] uint16 overflow: ${num}, clamped to ${Math.min(Math.max(0, num >>> 0), 0xffff)}`);
    num = Math.min(Math.max(0, num >>> 0), 0xffff);
  }
  buf.writeUInt16LE(num);
  return buf;
}

export function uint16BE(num: number): Buffer {
  const buf = Buffer.alloc(2);
  num = Number(num);
  if (num < 0 || num > 0xffff || !Number.isFinite(num)) {
    console.warn(`[BIN] uint16BE overflow: ${num}, clamped to ${Math.min(Math.max(0, num >>> 0), 0xffff)}`);
    num = Math.min(Math.max(0, num >>> 0), 0xffff);
  }
  buf.writeUInt16BE(num);
  return buf;
}

export function uint32(num: number): Buffer {
  const buf = Buffer.alloc(4);
  num = Number(num);
  if (num < 0 || num > 0xffffffff || !Number.isFinite(num)) {
    console.warn(`[BIN] uint32 overflow: ${num}, clamped to ${Math.min(Math.max(0, num), 0xffffffff)}`);
    num = Math.min(Math.max(0, num), 0xffffffff);
  }
  buf.writeUInt32LE(num);
  return buf;
}

// export function LVGLImgLoader(path: string) {
// const img = fs.readFileSync(path);
// 对齐
// if (img.length % 4 !== 0) {
//   return img.slice(4, -1);
// }
// return img.slice(4);
// return img;
// }

export function giveLastBitOne(num: any): number {
  if (num.toString(2).length < 32) {
    const binaryUid = num.toString(2).padStart(32, 0);
    let res = '';
    const lastBitOne = (0x80000000).toString(2);
    for (let i = 0; i < 32; i++) {
      const cur = Number(binaryUid[i]) | Number(lastBitOne[i]);
      res += cur;
    }
    return parseInt(res, 2);
  } else return Math.abs(num | 0x80000000);
}

export function giveLastBitZero(num: any): number {
  if (num.toString(2).length < 32) {
    const binaryUid = num.toString(2).padStart(32, 0);
    let res = '';
    const lastBitZero = (0x7fffffff as any).toString(2).padStart(32, 0);
    for (let i = 0; i < 32; i++) {
      const cur = Number(binaryUid[i]) && Number(lastBitZero[i]);
      res += cur;
    }
    return parseInt(res, 2);
  } else return Math.abs(num && Number(0x7fffffff));
}

export function uidColorGroupToZero(uid: Buffer): Buffer {
  const num = uid.readInt32LE();
  if (num.toString(2).length < 32) {
    const binaryUid = num.toString(2).padStart(32, '0');
    let res = '';
    const ColorGroupBitZero = (0xff87ffff as any).toString(2).padStart(32, 0);
    for (let i = 0; i < 32; i++) {
      const cur = Number(binaryUid[i]) && Number(ColorGroupBitZero[i]);
      res += cur;
    }
    return uint32(parseInt(res, 2));
  } else return uint32(Math.abs(num && Number(0xff87ffff)));
}

export function clearAll(): void {
  // 清除themeData
  for (const themeType in themeData) {
    themeData[themeType] = {
      name: '',
      recordsCount: new Array(getThemeTableTotalCount()).fill(0),
      records: []
    };
  }
  for (let i = 0; i < totalThemeRecordCount.length; i++) {
    totalThemeRecordCount[i] = 0;
  }
}

// 解析版本号
export function parseVersion(version: string): number {
  const vArr = version.split('.');
  const resArr = vArr.map((item) => {
    let hex = Number(item).toString(16);
    if (hex.length > 2) {
      hex = '00';
    } else if (hex.length < 2) {
      hex = `0${hex}`;
    }
    return hex;
  });
  const res = Number(`0x${resArr.join('')}`);
  return res;
}

export async function saveMap(
  xmlPath: string,
  names: string[],
  uids: any[]
): Promise<void> {
  const path = ElectronApi.path;
  if (path) {
    const binFilePath = path.resolve(xmlPath, '../uidmap.map');
    const uidmap: string[] = [];
    const fs = ElectronApi.fs;
    names.map((name, index) => {
      const map = `${name}: ${uids[index]}`;
      uidmap.push(map);
    });
    if (fs) await fs.promises.writeFile(binFilePath, uidmap.join('\n'));
  }
}

export function checkXml(ast: Ast): void {
  const resources = ast.children[0].children;
  const themes = ast.children.filter((item: Ast) => item.tag === 'Theme');
  console.log(resources, themes);
  themes.map((theme: Ast) => {
    const { type, name } = theme.attrsMap;
    theme.children.map((layout: Ast) => {
      const layoutRef = layout.attrsMap.ref.replace('@', '');
      findRef(resources, layoutRef);
    });
  });
}

function findRef(resources: Ast[], ref: string): Ast | undefined {
  const res = resources.find((item: Ast) => item.attrsMap.name === ref);
  if (res) {
    if (res.tag !== 'Image') return res;
  } else return undefined;
}
